module.exports = __webpack_public_path__ + "img/oem_help_short.3e437339.png";